<template>
  <div>
    <div>
      <RewardTable />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RewardTable from "@/components/Reward/RewardTableComponent.vue";

export default {
  name: "ViewRewardList",
  components: {
    RewardTable,
  },
  data() {
    return {};
  },
  computed: {
    username() {
      return this.$store.state.userInfo.userName;
    },
  },
};
</script>
